<template>
  <div ref="sectionRef" class="w-full overflow-hidden">
    <Transition name="fade" class="delay-600">
      <Swiper
        v-if="data"
        :modules="modules"
        class="slider featured-location-cards relative"
        :slides-per-view="1"
        :space-between="8"
        :speed="500"
        :lazy-preload-prev-next="1"
        :breakpoints="{
          1024: {
            slidesPerView: 'auto',
            allowTouchMove: false
          }
        }"
      >
        <SwiperSlide v-for="(item, idx) in data" :key="idx" class="lg:max-w-[572px]">
          <Image
            v-if="item"
            class="aspect-[16/10] object-cover"
            :src="item.responsiveImage ? item.responsiveImage?.src : item.url"
            :srcset="item.responsiveImage ? item.responsiveImage?.webpSrcSet : undefined"
            :width="item.responsiveImage ? item.responsiveImage?.width : (item.width ?? 20)"
            :height="item.responsiveImage ? item.responsiveImage?.height : (item.height ?? 20)"
            :alt="item.alt ?? ''"
          />
          <div
            class="absolute left-0 top-0 z-2 flex h-full w-fit rotate-180 items-center justify-between gap-2 whitespace-nowrap py-2 text-sm uppercase mix-blend-difference [text-orientation:mixed] [writing-mode:vertical-lr]"
          >
            <span>
              {{ item?.title }}
            </span>
            <span class="inline-flex gap-4">
              {{ country?.locale }}
              <span>{{ category?.name }}</span>
            </span>
          </div>
        </SwiperSlide>
        <SwiperCursors />
      </Swiper>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type {
  CountryRecord,
  FileField,
  LocationCategoryRecord,
  LocationRecord
} from '~/types/datocms'

import 'swiper/css'

const modules = [Parallax, A11y]

defineProps({
  data: {
    type: Array as PropType<FileField[]>,
    default: () => []
  },
  location: {
    type: Object as PropType<LocationRecord>,
    default: () => ({})
  },
  country: {
    type: Object as PropType<CountryRecord>,
    default: () => ({})
  },
  category: {
    type: Object as PropType<LocationCategoryRecord>,
    default: () => ({})
  }
})
</script>

<style lang="postcss">
.featured-location-cards {
  @apply container !overflow-visible;

  .swiper-wrapper {
    @apply box-border transform-gpu items-stretch !px-0 lg:ease-in-out;
  }

  .swiper-slide {
    @apply flex flex-col justify-end transition-all duration-300;
  }
}
</style>
